import React from "react";
import { FaRegTrashAlt } from "react-icons/fa";
import Stripe from "../utils/Icons/Stripe.svg";
import Paypal from "../utils/Icons/Paypal.svg";
export const Checkout = () => {
  return (
    <div className="flex justify-between px-4 space-x-4  py-10">
      <div className="  rounded-lg p-6 w-full">
        <div className="md:flex items-center justify-between">
          <h1 className="text-[28px] pb-5">Billing Details</h1>
        </div>
        <label htmlFor="email">Email Address</label>
        <br />
        <input
          className="bg-white dark:border-gray-600 dark:bg-[#1C1C1C] my-2 w-full  rounded-lg border px-4 py-3 bg-transparent"
          name="email"
          type="email"
          placeholder="dorin.andrei@premiumuikits.com"
        />
        <label htmlFor="address">Address</label>
        <br />
        <input
          className="bg-white dark:border-gray-600 dark:bg-[#1C1C1C] my-2 w-full  rounded-lg border px-4 py-3 bg-transparent"
          name="address"
          type="text"
          placeholder="Furtunei 28, et.2 , sector 6"
        />
        <br />
        <div className="w-full  flex-col lg:flex-row flex items-center lg:space-x-2">
          <div className="w-full">
            <label htmlFor="Country">Country</label>
            <br />
            <select
              name="countries"
              className="bg-white dark:border-gray-600 dark:bg-[#1C1C1C] my-2 w-full rounded-lg border px-4 py-3 bg-transparent"
              id="countries"
            >
              <option value="Romania">Romania</option>
              <option value="Romania">Romania</option>
              <option value="Romania">Romania</option>
              <option value="Romania">Romania</option>
            </select>
          </div>
          <div className="w-full">
            <label htmlFor="City">City</label>
            <br />
            <input
              className="bg-white dark:border-gray-600 dark:bg-[#1C1C1C] my-2 w-full rounded-lg border px-4 py-3 bg-transparent"
              name="City"
              type="text"
              placeholder="Romania"
            />
          </div>
          <div className="w-full">
            <label htmlFor="Zip">Zip or Postal Code</label>
            <br />
            <input
              className="bg-white dark:border-gray-600 dark:bg-[#1C1C1C] my-2 w-full rounded-lg border px-4 py-3 bg-transparent"
              name="City"
              type="text"
              placeholder="Romania"
            />
          </div>
        </div>

        <div className="flex items-center space-x-2">
          <input
            className="bg-white dark:border-gray-600 "
            type="checkbox"
            name=""
            id=""
          />
          <p>Check if you are a company</p>
        </div>
        <div className="py-8">
          <h3 className="text-2xl">Payment Details</h3>
          <div className="flex items-center space-x-4 pt-5 w-1/2">
            <div className="flex items-center space-x-2 w-full shrink-0 rounded-xl bg-[#635BFF] px-4 py-3 justify-center text-white">
              <img src={Stripe} alt="" />
              <p className="text-lg">Buy with Stripe</p>
            </div>
            <div className="flex items-center w-full space-x-2 shrink-0 rounded-xl dark:bg-white px-4 py-3 justify-center dark:text-[#1c1c1c] bg-[#1c1c1c] text-white">
              <img src={Paypal} alt="" />
              <p className="text-lg">Buy with PayPal</p>
            </div>
          </div>
        </div>
        <p>By continuing you're consenting to our <span className="underline">privacy policy</span>. </p>
      </div>
      <div className="w-1/2 bg-[#F0F0F0] dark:bg-[#282828] p-4  h-fit rounded-lg">
        <div className="flex items-center justify-between space-x-4">
          <h1 className="text-xl">Your Cart (2)</h1>
          {/* <button className="" onClick={() => setShowCart(prev => !prev)}><IoClose className="text-xl"/></button> */}
        </div>
        <hr className="my-4 border-[#D3D3D3] dark:border-gray-500" />
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <img
              className="w-[52px] h-[48px] rounded-lg"
              src="https://images.pexels.com/photos/13070618/pexels-photo-13070618.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              alt=""
            />
            <div>
              <p>Atro Figma Mobile UI Kit</p>
              <p>UI Kits</p>
            </div>
          </div>
          <div>
            <p>$39</p>
            <FaRegTrashAlt className="text-red-500  border-[2px] border-[#D3D3D3] dark:border p-2 text-3xl rounded-md" />
          </div>
        </div>
        <hr className="my-4 border-[#D3D3D3] dark:border-gray-500" />
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <img
              className="w-[52px] h-[48px] rounded-lg"
              src="https://images.pexels.com/photos/27260680/pexels-photo-27260680/free-photo-of-red-flower.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              alt=""
            />
            <div>
              <p>Atro Figma Mobile UI Kit</p>
              <p>UI Kits</p>
            </div>
          </div>
          <div>
            <p>$39</p>
            <FaRegTrashAlt className="text-red-500 border-[2px] border-[#D3D3D3] dark:border p-2 text-3xl rounded-md" />
          </div>
        </div>
        <hr className="my-4 border-[#D3D3D3] dark:border-gray-500" />
        <div>
          <div className="flex items-center justify-between">
            <p>Cart items</p>
            <p>$78</p>
          </div>
          <div className="flex items-center justify-between">
            <p>VAT (19%)</p>
            <p>$11.98</p>
          </div>
          <div className="flex items-center justify-between">
            <p>Total to pay</p>
            <p>$98.97</p>
          </div>
        </div>
      </div>
    </div>
  );
};
